/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Offers_HintInputs */

const en_directory_submit_offers_hint = /** @type {(inputs: Directory_Submit_Offers_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer visitors a promo code to use on your site. Shown on your listing with a copy button.`)
};

const zh_directory_submit_offers_hint = /** @type {(inputs: Directory_Submit_Offers_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为访客提供一个在你网站上使用的促销码，会显示在你的条目上并带复制按钮。`)
};

/**
* | output |
* | --- |
* | "Offer visitors a promo code to use on your site. Shown on your listing with a copy button." |
*
* @param {Directory_Submit_Offers_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_offers_hint = /** @type {((inputs?: Directory_Submit_Offers_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Offers_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_offers_hint(inputs)
	return zh_directory_submit_offers_hint(inputs)
});
export { directory_submit_offers_hint as "directory.submit.offers_hint" }